import { ModalFooter } from '@/components/Modal'

export function Footer() {
  return <ModalFooter primaryAction={<div />} />
}
